import { Tabs, TabsProps } from "antd";
import { RegistrationAnalysisstepPerMonth } from "features/dashboard/components/Registration/Registration-Analysis-stepPerMonth";
import { RegistrationanalysisstepaView } from "features/dashboard/components/Registration/Registration-Analysis-stepTarget";
import { Fragment } from "react/jsx-runtime"

import { DemographicregistrationView } from "./Demographic";
import { RegistrationCrossSalesView } from "./registration-cross-sales";

export const RegistrationCross = () => {
   
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Registration Analysis',
            children:<RegistrationanalysisstepaView />,
        },
        {
            key: '2',
            label: 'Registration Analysis Per Month',
            children: <RegistrationAnalysisstepPerMonth/>,
        },
        {
            key: '3',
            label: 'Cross Sales',
            children: <RegistrationCrossSalesView/>,
        },
         {
            key: '4',
            label: 'Demographic',
            children: <DemographicregistrationView />,
        },
    ];

    return (
        <Fragment>
            <Tabs defaultActiveKey="1" items={items}  />
        </Fragment>
    )
}